module.exports = __webpack_public_path__ + "static/media/ico_longtext.dce6be15.svg";